import React from "react";
import FocusLock from "react-focus-lock";
import { ModalContext } from "../context/Modal.js";
function Modals() {
    const modalContext = React.useContext(ModalContext);
    const modalState = modalContext.data;
    const hasModals = modalState.stack.length > 0;
    function keyListener(e) {
        switch (e.keyCode) {
            case 27:
                modalContext.despawnModal();
                break;
        }
    }
    React.useEffect(() => {
        if (hasModals) {
            document.body.style.overflow = "hidden";
            window.addEventListener("keydown", keyListener);
        }
        else {
            document.body.style.overflow = "visible";
        }
        return () => {
            window.removeEventListener("keydown", keyListener);
        };
    }, [hasModals, modalState]);
    const Elem = modalContext.opts && modalContext.opts.customBackdrop
        ? modalContext.opts.customBackdrop
        : Default;
    return hasModals ? (React.createElement(React.Fragment, null, modalState.stack.map((m, k) => {
        return (React.createElement(Elem, { key: k, className: "modal-backdrop", style: { zIndex: 3 + k } },
            React.createElement("div", { style: { zIndex: 4 + k }, className: "modal-wrapper", role: "dialog", "aria-modal": true },
                React.createElement(FocusLock, null,
                    " ",
                    m.content))));
    }))) : null;
}
const Default = ({ children, ...props }) => React.createElement("div", { ...props }, children);
export default Modals;
//# sourceMappingURL=Modals.js.map